/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Configuration to set default write values for object fields.
 * @export
 * @interface ValueDefaults
 */
export interface ValueDefaults {
    /**
     * If true, users can set default values for any field.
     * @type {boolean}
     * @memberof ValueDefaults
     */
    allowAnyFields?: boolean;
}

/**
 * Check if a given object implements the ValueDefaults interface.
 */
export function instanceOfValueDefaults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ValueDefaultsFromJSON(json: any): ValueDefaults {
    return ValueDefaultsFromJSONTyped(json, false);
}

export function ValueDefaultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValueDefaults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowAnyFields': !exists(json, 'allowAnyFields') ? undefined : json['allowAnyFields'],
    };
}

export function ValueDefaultsToJSON(value?: ValueDefaults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowAnyFields': value.allowAnyFields,
    };
}

